module.exports = __webpack_public_path__ + "img/icon-copy.624ba435.svg";